import { Layout, theme as antdTheme } from 'antd';
import { Outlet, Navigate, useLocation } from 'react-router';
import { useEffect } from 'react';
import { useAuthStore } from '@/store/auth';
import { AppSider } from '@/app/sider';
import { AppHeader } from '@/app/header';
import { CommandPalette } from '@/app/command-palette';
import { AppShortcuts } from '@/app/shortcuts';
import { useCommandPaletteStore } from '@/store/command-palette';
import { useDashboardNotifications } from '@/app/use-dashboard-notifications';
import { useScrollRestoration } from '@/shared/hooks/use-scroll-restoration';
import { useTrackRecentPage } from '@/shared/hooks/use-track-recent-page';

export function AppLayout() {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const { token: t } = antdTheme.useToken();
  const toggle = useCommandPaletteStore((s) => s.toggle);

  // Cmd/Ctrl+K opens the palette from anywhere.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [toggle]);

  // Auto-seed bell notifications from dashboard summary.
  useDashboardNotifications();

  // Preserve scroll on back/forward across the SPA.
  useScrollRestoration();

  // Track recent visits for the command palette's empty-query view.
  useTrackRecentPage();

  if (!token) return <Navigate to="/login" replace />;
  if (user?.mustChangePassword) return <Navigate to="/change-password" replace />;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppSider />
      <Layout style={{ background: t.colorBgLayout }}>
        <AppHeader />
        <Layout.Content style={{ padding: '24px 28px', minHeight: 0, overflowX: 'hidden' }}>
          <div key={location.key} className="page-fade">
            <Outlet />
          </div>
        </Layout.Content>
      </Layout>
      <CommandPalette />
      <AppShortcuts />
    </Layout>
  );
}
